/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = erfolgt (erfolgt)
 * 
 * 805290001 = ausstehend (ausstehend)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceErfolgtausstehend {
 erfolgt = 805290000,
 ausstehend = 805290001
}

marker([
    "Enum.GlobalEnumsAceErfolgtausstehend.erfolgt",
    "Enum.GlobalEnumsAceErfolgtausstehend.ausstehend"
]);

export namespace GlobalEnumsAceErfolgtausstehend
{
    class DataSets
    {
        static GlobalEnumsAceErfolgtausstehendDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("erfolgt", 805290000, "erfolgt"),
            new EnumValue("ausstehend", 805290001, "ausstehend"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceErfolgtausstehendDataSet;
    }
}
